import React from 'react'
import { createRoot } from 'react-dom/client'
import ProductTile from "./ProductTile.jsx"
import { makeRequest, makeProduct } from "../../utils/Storefront.js"

const appAttribute = 'product-tile'
const apiAttribute = 'data-plp-item'

document.addEventListener('DOMContentLoaded', () => {
  // const observeRoot = document.querySelector('#MainContent')
  // const config = { childList: true, subtree: true }
  // const observer = new MutationObserver(observerCallback)
  // observer.observe(observeRoot, config)

  const productTiles = document.querySelectorAll(`[${appAttribute}]:not([initial-load="false"])`)
  productTiles.forEach((tile) => setupProductTile(tile))

  setupApiTiles()  
})

// const observerCallback = (mutationList, observer) => {
//   mutationList.forEach((mutation) => {
//     mutation.addedNodes.forEach((node) => {
//       if (!(node instanceof HTMLElement)) return
//       if (node.hasAttribute(appAttribute)) setupProductTile(node)
//     })
//   })
// }

const setupApiTiles = (parent=document) => {
  const apiTiles = parent.querySelectorAll(`[${apiAttribute}][data-inited="false"]`)
  apiTiles.forEach(tile => tile.setAttribute('data-inited', 'true'))
  const ids = Array.from(apiTiles).map(tile => `"gid://shopify/Product/${tile.dataset.plpItem}"`)
  const query = `{
    nodes(ids: [${ids.join(',')}]) {
      ...on Product {
        ${window.productResponse}
      }
    }
  }`
  makeRequest(
    (results) => {
      results.data.nodes.forEach(node => {
        const json = makeProduct(node)
        if(json) {
          const wrapper = parent.querySelector(`[${apiAttribute}="${json.id}"]`)
          const tile = document.createElement('div')
          tile.id = `plp-tile-${json.id}`
          tile.setAttribute('product-tile', json.id)
          tile.setAttribute('json', JSON.stringify(json))
          tile.setAttribute('lazyload', wrapper.getAttribute('lazyload'))
          tile.setAttribute('columns_desktop', wrapper.getAttribute('columns_desktop'))
          tile.setAttribute('columns_tablet', wrapper.getAttribute('columns_tablet'))
          tile.setAttribute('columns_mobile', wrapper.getAttribute('columns_mobile'))
          tile.setAttribute('preselected_colors', wrapper.getAttribute('preselected_colors'))
          tile.setAttribute('flatlay', wrapper.getAttribute('flatlay'))
          tile.setAttribute('real_price', wrapper.getAttribute('data-real-price'))
          tile.setAttribute('real_comp_price', wrapper.getAttribute('data-real-comp-price'))
          tile.setAttribute('plp_index', wrapper.getAttribute('data-plp-index'))
          const div = document.createElement('div')
          div.appendChild(tile)
          wrapper.innerHTML = div.innerHTML
          setTimeout(() => {
            setupProductTile(wrapper.querySelector(`[${appAttribute}="${json.id}"]`))
          }, 100)
        }
      })
      setTimeout(() => {
        window._swat.initializeActionButtons('#MainContent', '.plp-wishlist-btn')
      }, 1500)
    },
    query
  )
}
window.setupApiTiles = setupApiTiles

const setupProductTile = (productTileEl) => {
  if(typeof productTileEl != 'undefined') {
    const jsonRaw = productTileEl.getAttribute('json')
    const json = JSON.parse(jsonRaw)
    const lazyloadRaw = productTileEl.getAttribute('lazyload')
    const lazyload = (typeof lazyloadRaw == 'undefined' ? true : lazyloadRaw)
    const searchRaw = productTileEl.getAttribute('search')
    const search = (typeof searchRaw == 'undefined' ? true : searchRaw)
    const columnsDesktopRaw = productTileEl.getAttribute('columns_desktop')
    const columnsDesktop = columnsDesktopRaw || 4
    const columnsTabletRaw = productTileEl.getAttribute('columns_tablet')
    const columnsTablet = columnsTabletRaw || 2
    const columnsMobileRaw = productTileEl.getAttribute('columns_mobile')
    const columnsMobile = columnsMobileRaw || 2
    const preselectedColorsRaw = productTileEl.getAttribute('preselected_colors')
    const preselectedColors = (preselectedColorsRaw || '').toLowerCase()
    const addonRaw = productTileEl.getAttribute('addon')
    const addon = (addonRaw || '').toLowerCase()
    const showcaseRaw = productTileEl.getAttribute('showcase')
    const showcase = (showcaseRaw || '').toLowerCase()
    const flatlayRaw = productTileEl.getAttribute('flatlay')
    const flatlay = (flatlayRaw || '').toLowerCase()
    const multipleRaw = productTileEl.getAttribute('multiple')
    const multiple = (multipleRaw || 'true').toLowerCase()
    const selectedVariantIdRaw = productTileEl.getAttribute('selected_variant_id')
    const selectedVariantId = (selectedVariantIdRaw || '').toLowerCase()

    const realPriceRaw = productTileEl.getAttribute('real_price')
    const realPrice = parseInt(realPriceRaw) || 0
    const realCompPriceRaw = productTileEl.getAttribute('real_comp_price')
    const realCompPrice = parseInt(realCompPriceRaw) || 0
    const plpIndexRaw = productTileEl.getAttribute('plp_index')
    const plpIndex = plpIndexRaw ? parseInt(plpIndexRaw) : null
    
    const root = createRoot(productTileEl)
    root.render(
      <ProductTile json={json} 
        lazyload={lazyload} 
        search={search}
        columnsDesktop={columnsDesktop}
        columnsTablet={columnsTablet}
        columnsMobile={columnsMobile}
        preselectedColors={preselectedColors}
        addon={addon}
        showcase={showcase}
        flatlay={flatlay}
        multiple={multiple}
        selectedVariantId={selectedVariantId}
        realPrice={realPrice}
        realCompPrice={realCompPrice}
        plpIndex={plpIndex}
      />
    )
  }
}

window.setupATile = setupProductTile

window.setupProductTiles = (tiles) => {
  tiles.forEach((tile) => setupProductTile(tile))
}